@if (label()) {
  <span class="esn-dropdown-field__label" [id]="id + '-label'">{{ label() }}</span>
}
<div class="esn-dropdown-field__anchor">
  <button
    type="button"
    role="combobox"
    class="esn-dropdown-field__trigger"
    aria-haspopup="listbox"
    [class.esn-dropdown-field__trigger--open]="open()"
    [disabled]="isDisabled()"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="id + '-listbox'"
    [attr.aria-labelledby]="label() ? id + '-label ' + id + '-value' : null"
    [attr.aria-activedescendant]="activeId()"
    (click)="toggle()"
    (keydown)="handleKeydown($event)"
    (blur)="handleBlur()"
  >
    <span
      class="esn-dropdown-field__value"
      [class.esn-dropdown-field__value--placeholder]="!selected()"
      [id]="id + '-value'"
    >{{ selected()?.label ?? placeholder() }}</span>
    <esn-icon class="esn-dropdown-field__chevron" name="arrow-down-30" [size]="30" />
  </button>

  @if (open()) {
    <ul class="esn-dropdown-field__listbox" role="listbox" [id]="id + '-listbox'" [attr.aria-labelledby]="label() ? id + '-label' : null">
      @for (option of options(); track option.value; let i = $index) {
        <li
          role="option"
          class="esn-dropdown-field__option"
          [id]="id + '-option-' + i"
          [class.esn-dropdown-field__option--active]="i === activeIndex()"
          [class.esn-dropdown-field__option--selected]="option.value === value()"
          [attr.aria-selected]="option.value === value()"
          [attr.aria-disabled]="option.disabled || null"
          (mousedown)="$event.preventDefault()"
          (mouseenter)="option.disabled || activeIndex.set(i)"
          (click)="choose(i)"
        >{{ option.label }}</li>
      }
    </ul>
  }
</div>
